import { render, staticRenderFns } from "./TalentLink.vue?vue&type=template&id=44e7eec6&scoped=true&"
import script from "./TalentLink.vue?vue&type=script&lang=js&"
export * from "./TalentLink.vue?vue&type=script&lang=js&"
import style0 from "./TalentLink.vue?vue&type=style&index=0&id=44e7eec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e7eec6",
  null
  
)

export default component.exports